import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { SearchOutlined } from "@ant-design/icons";
import { validations } from "../../../../config/validations/validations";
import { disabledSaveBtn } from "../../../../config/Global";
// import { validations } from '../../../../config/validations/validations';

const SearchForm: React.FC<any> = (props) => {
  const { paginationData, getList, setSavePayload } = props;

  const [form] = Form.useForm();

  const [searchBy, setSearchBy] = useState<string>("from_number");
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);

  useEffect(() => {
    form.setFieldValue("search_by", searchBy);
  }, [form, searchBy]);

  const handleSubmit = (data) => {
    setSavePayload(data);
    let payload = {};

    if (searchBy === "from_number") {
      payload = {
        number: data?.number,
      };
    } else if (searchBy === "to_number") {
      payload = {
        to_number: data?.to_number,
      };
    } else {
      payload = {
        ...paginationData,
      };
    }

    getList(payload);
    setDisabledClear(false);
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
        initialValues={{
          message_action: "from_number",
          //   status: 'All',
        }}
      >
        <Row gutter={[20, 0]} align={"top"}>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Select
              label="Search By"
              name={"search_by"}
              allowClear
              showSearch
              initialValue={searchBy}
              options={{
                list: [
                  { id: "from_number", name: "Phone Number" },
                  { id: "to_number", name: "To Number" },
                ],
                valueKey: "id",
                textKey: "name",
              }}
              onChange={(val: string) => {
                setSearchBy(val);
                if (val === "from_number") {
                  form.setFields([
                    {
                      name: "number",
                      errors: ["It is required."],
                    },
                  ]);
                } else {
                  form.setFields([
                    {
                      name: "to_number",
                      errors: ["It is required."],
                    },
                  ]);
                }

                //console.log('val', val);
              }}
              // required
              // rules={[validations.required.select('Message')]}
            />
          </Col>

          <Col xs={24} md={12} lg={6}>
            {searchBy === "from_number" ? (
              <InputBox.Text
                label="Phone Number"
                name={"number"}
                required
                rules={[
                  validations.required.text(),
                  validations.pattern.numericWithSecial,
                  validations.pattern.whitespace,
                ]}
              />
            ) : (
              <InputBox.Text
                label="To Number"
                name={"to_number"}
                required
                rules={[
                  validations.required.text(),
                  validations.pattern.numericWithSecial,
                  validations.pattern.whitespace,
                ]}
              />
            )}
          </Col>

          {/* <Col xs={24} md={12} lg={4}>
                <InputBox.Select
                  label='Status'
                  name={'status'}
                  allowClear
                  showSearch
                  initialValue={'All'}
                  options={{
                    list: status && status,
                    valueKey: 'value',
                    textKey: 'label',
                  }}
                />
              </Col> */}
        </Row>
        <Row gutter={[20, 0]}>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button type="primary" disabled={disabledSearch} htmlType="submit">
              <SearchOutlined /> Search
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button
              type="default"
              // htmlType="reset"
              onClick={() => {
                form.resetFields();
                form.setFieldsValue({ search_by: searchBy });
                setSavePayload();
                const update = {
                  current: 1,
                  page_size: 10,
                };
                getList(update);
                setDisabledSearch(true);
                setDisabledClear(true);
              }}
              disabled={disabledClear}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default SearchForm;
